import NavigationAdmin from './NavigationAdmin'
import Breadcrumbs from './Breadcrumbs'
import ColorMode from './ColorMode'
import Fullscreen from './Fullscreen'
import UserInfo from './UserInfo'
import { Outlet } from 'react-router-dom'

const LayoutAdmin = ({ user, setUser }) => {
  return (
    <>
      {/* Navigace */}
      <NavigationAdmin user={user} setUser={setUser} />

      <main className="main-admin m-0 mt-4 m-xl-3 px-4 py-xl-2">        

        <div className="row d-flex align-items-center justify-content-between mb-0 admin-toolbar">
          {/* Nadpis a breadcrumbs */}
          <div className="col">
            <Breadcrumbs />            
          </div>
          
          {/* Uživatelský box */}
          <div className="col-auto d-none d-md-flex align-items-center align-self-start gap-2 admin-toolbar-userbox">
            <ColorMode />
            <Fullscreen />
            <UserInfo user={user} />
          </div>
        </div>


        {/* Obsah stránky */}
        <Outlet />

      </main>
    </>
  )
}

export default LayoutAdmin
